import React from 'react';
import { formatRelativeDate } from '../../utils/relativeTime';

/**
 * Cellule « Site web » d'un client dans la liste :
 * domaine cliquable + badge En ligne / Non publié + date de dernière publication.
 * @param {Object} props
 * @param {Object|null} props.client - Ligne client (contient client.site)
 */
const ClientSiteCell = ({ client }) => {
  const site = client.site;

  if (!site || !site.domainName) {
    return (
      <div>
        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-base-200 text-base-content/60 border border-base-200">
          {site ? 'Non publié' : 'Aucun site'}
        </span>
      </div>
    );
  }

  return (
    <div className="min-w-[160px]">
      <a
        href={`https://${site.domainName}`}
        target="_blank"
        rel="noopener noreferrer"
        className="text-info hover:text-info-focus hover:underline text-sm font-medium break-all"
        title={`Visiter ${site.domainName}`}
      >
        {site.domainName}
      </a>
      <div className="flex items-center gap-2 mt-0.5">
        <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium bg-success/15 text-success border border-success/25">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-3 h-3 mr-1">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" />
          </svg>
          En ligne
        </span>
        <span className="text-xs text-base-content/60">
          Publié {formatRelativeDate(site.publishedAt)}
        </span>
      </div>
    </div>
  );
};

export default ClientSiteCell;
